import _classCallCheck from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
var i = Object.defineProperty;
var d = function d(t, e, n) {
  return e in t ? i(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : t[e] = n;
};
var r = function r(t, e, n) {
  return d(t, typeof e != "symbol" ? e + "" : e, n), n;
};
var o = /*#__PURE__*/function () {
  function o() {
    _classCallCheck(this, o);
    r(this, "current", this.detect());
    r(this, "handoffState", "pending");
    r(this, "currentId", 0);
  }
  _createClass(o, [{
    key: "set",
    value: function set(e) {
      this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.set(this.detect());
    }
  }, {
    key: "nextId",
    value: function nextId() {
      return ++this.currentId;
    }
  }, {
    key: "isServer",
    get: function get() {
      return this.current === "server";
    }
  }, {
    key: "isClient",
    get: function get() {
      return this.current === "client";
    }
  }, {
    key: "detect",
    value: function detect() {
      return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
  }, {
    key: "handoff",
    value: function handoff() {
      this.handoffState === "pending" && (this.handoffState = "complete");
    }
  }, {
    key: "isHandoffComplete",
    get: function get() {
      return this.handoffState === "complete";
    }
  }]);
  return o;
}();
var s = new o();
export { s as env };